import * as React from "react";
import { SpinnerElement } from "src/theme/objects/SpinnerElement";
import KudosContext from "src/context";

export class SpinnerComponent extends React.Component<{}, {}> {
  public static contextType = KudosContext;
  public context!: React.ContextType<typeof KudosContext>;

  public render() {
    return <SpinnerElement show={this.context!.showSpinner} />;
  }
}
